import { ActionButton, CudaDialogTitle, LoadingDialogContent } from 'common/components/CudaDialog'
import DialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Dialog from '@material-ui/core/Dialog';
import Table from '@material-ui/core/Table';
import Grid from '@material-ui/core/Grid';
import React from 'react';

const style = {
    root: {
        '& input, textarea': {
            width: '100%',
        }
    },
}

const SearchServicesServerDialog = ({ 
    classes, 
    isOpen,
    close,
    containers,
    loading,
    }) =>{

    return (
        <Dialog open={isOpen} transitionDuration={0} maxWidth="xl" onClose={close} className={classes.root}>
            <CudaDialogTitle onRequestClose={close}>
                Detailed Health Report
            </CudaDialogTitle>
            <LoadingDialogContent loading={loading}>
                <Grid container alignItems='center'>
                    <Grid item>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Timestamp</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>Health</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>RLCZ</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>Container ID</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {'error' in containers ? 
                                <TableRow>
                                    <TableCell colSpan={4} textAlign="center">{containers['error']}</TableCell>
                                </TableRow>
                                :
                                containers.map((container, i) => 
                                <TableRow key={container['container_id']}>
                                    <TableCell>{container['timestamp']}</TableCell>
                                    <TableCell>
                                        <Typography variant="subtitle2" color={container['is_up'] ? 'secondary' : 'error'}>{container['is_up'] ? 'Up' : 'Down'}</Typography>
                                    </TableCell>
                                    <TableCell>{container['RLCZ']}</TableCell>
                                    <TableCell>...{container['container_id'].slice(-20)}</TableCell>
                                </TableRow>)
                                }
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
            </LoadingDialogContent>
            <DialogActions>
                <ActionButton onClick={close}>
                    Close
                </ActionButton>
            </DialogActions>
        </Dialog>
    )
};

export default withStyles(style)(SearchServicesServerDialog);
